import type { Tenant } from '../types/deal';

export interface TenantFieldConfig {
  field: keyof Tenant;
  label: string;
}

export const TENANT_FIELD_CONFIG: TenantFieldConfig[] = [
  { field: 'asset_name' as keyof Tenant, label: 'Asset Name' },
  { field: 'tenant_name', label: 'Tenant Name' },
  { field: 'tenant_sector', label: 'Tenant Sector' },
  { field: 'lease_start_date', label: 'Lease Start Date' },
  { field: 'lease_end_date', label: 'Lease End Date' },
  { field: 'break_option_date', label: 'Break Option Date' },
  { field: 'next_review_date', label: 'Next Review Date' },
  { field: 'contracted_rent', label: 'Contracted Rent' },
  { field: 'passing_rent', label: 'Passing Rent' },
  { field: 'rent_free_amount', label: 'Rent Free Amount' },
  { field: 'rent_free_end_date', label: 'Rent Free End Date' },
  { field: 'rent_currency', label: 'Rent Currency' },
  { field: 'total_area', label: 'Total Area' },
  { field: 'area_type', label: 'Area Type' },
  { field: 'estimated_rental_value', label: 'Estimated Rental Value' },
  { field: 'tf_erv', label: 'TF ERV' },
  { field: 'unit_type', label: 'Unit Type' },
  { field: 'count_parking', label: 'No. of Parking Spaces' },
  { field: 'parking_erv', label: 'Parking ERV' },
  { field: 'parking_income', label: 'Parking Income' },
  { field: 'ios_area', label: 'IOS Area' },
  { field: 'ios_erv', label: 'IOS ERV' },
  { field: 'ios_income', label: 'IOS Income' },
];

